type Bank = {
	code: string;
	name: string;
	shortName?: string;
	logo?: string;
	logoSvg?: string;
	order: number;
	type: string[];
	category?: string;
};

export const banksInfo: Bank[] = [
	// Banks with logos (prioritized)
	{
		code: "stateBankOfIndia",
		name: "State Bank of India",
		shortName: "SBI",
		logo: "/images/banks/sbi.png",
		logoSvg: "/images/banks/sbi.svg",
		order: 1,
		type: ["public", "government"],
		category: "major",
	},
	{
		code: "hDFCBank",
		name: "HDFC Bank",
		shortName: "HDFC",
		logo: "/images/banks/hdfc.png",
		logoSvg: "/images/banks/hdfc.svg",
		order: 2,
		type: ["private"],
		category: "major",
	},
	{
		code: "iCICIBank",
		name: "ICICI Bank",
		shortName: "ICICI",
		logo: "/images/banks/icici.png",
		logoSvg: "/images/banks/icici.svg",
		order: 3,
		type: ["private"],
		category: "major",
	},
	{
		code: "axisBank",
		name: "Axis Bank",
		shortName: "Axis",
		logo: "/images/banks/axis.png",
		logoSvg: "/images/banks/axis.svg",
		order: 4,
		type: ["private"],
		category: "major",
	},
	{
		code: "punjabNationalBank",
		name: "Punjab National Bank",
		shortName: "PNB",
		logo: "/images/banks/pnb.png",
		logoSvg: "/images/banks/pnb.svg",
		order: 5,
		type: ["public", "government"],
		category: "major",
	},
	{
		code: "citibankIndia",
		name: "Citibank India",
		shortName: "Citibank",
		logo: "/images/banks/citibank.png",
		logoSvg: "/images/banks/citibank.svg",
		order: 6,
		type: ["foreign"],
		category: "international",
	},
	{
		code: "standardChartered",
		name: "Standard Chartered Bank",
		shortName: "Standard Chartered",
		logo: "/images/banks/sc.png",
		logoSvg: "/images/banks/sc.svg",
		order: 7,
		type: ["foreign"],
		category: "international",
	},
	{
		code: "iDFC",
		name: "IDFC First Bank",
		shortName: "IDFC First",
		logo: "/images/banks/idfc.png",
		order: 8,
		type: ["private"],
		category: "new-generation",
	},
	{
		code: "federalBankLtd",
		name: "Federal Bank Ltd",
		shortName: "Federal Bank",
		logo: "/images/banks/fb.png",
		order: 9,
		type: ["private"],
		category: "regional",
	},
	// Other banks without logos
	{ code: "abuDhabiCommercialBankLtd", name: "Abu Dhabi Commercial Bank Ltd", order: 100, type: ["foreign"] },
	{ code: "aBBankLtd", name: "AB Bank Ltd", order: 101, type: ["private"] },
	{ code: "ahmedabadMercantileCo-opBank", name: "Ahmedabad Mercantile Co-op Bank", order: 102, type: ["cooperative"] },
	{ code: "allahabadBank", name: "Allahabad Bank", order: 103, type: ["public"] },
	{ code: "andhraBank", name: "Andhra Bank", order: 104, type: ["public"] },
	{ code: "antwerpDiamondBankMumbai", name: "Antwerp Diamond Bank Mumbai", order: 105, type: ["foreign"] },
	{ code: "bajajFinserv", name: "Bajaj Finserv", order: 106, type: ["nbfc"] },
	{ code: "bankOfAmerica", name: "Bank Of America", order: 107, type: ["foreign"] },
	{ code: "bankOfBaroda", name: "Bank of Baroda", order: 108, type: ["public"] },
	{ code: "bankOfCeylon", name: "Bank Of Ceylon", order: 109, type: ["foreign"] },
	{ code: "bankOfIndia", name: "Bank of India", order: 110, type: ["public"] },
	{ code: "bankOfMaharashtra", name: "Bank Of Maharashtra", order: 111, type: ["public"] },
	{ code: "bankOfNovaScotia", name: "Bank Of Nova Scotia", order: 112, type: ["foreign"] },
	{ code: "bankOfTokyo-MitsubishiUfjLtd", name: "Bank Of Tokyo-Mitsubishi Ufj Ltd", order: 113, type: ["foreign"] },
	{ code: "bankInternasionalIndonesia", name: "Bank Internasional Indonesia", order: 114, type: ["foreign"] },
	{ code: "barclaysBankPlc", name: "Barclays Bank Plc", order: 115, type: ["foreign"] },
	{ code: "bharatCo-opBank(Mumbai)Ltd", name: "Bharat Co-op Bank (Mumbai) Ltd", order: 116, type: ["cooperative"] },
	{ code: "bNPParibas", name: "BNP Paribas", order: 117, type: ["foreign"] },
	{ code: "canaraBank", name: "Canara Bank", order: 118, type: ["public"] },
	{ code: "canFinHomes", name: "Can Fin Homes", order: 119, type: ["nbfc"] },
	{ code: "catholicSyrianBankLtd", name: "Catholic Syrian Bank Ltd", order: 120, type: ["private"] },
	{ code: "centralBankofIndia", name: "Central Bank of India", order: 121, type: ["public"] },
	{ code: "chinatrustCommercialBank", name: "Chinatrust Commercial Bank", order: 122, type: ["foreign"] },
	{ code: "citizencreditCo-opBankLtd", name: "Citizencredit Co-op Bank Ltd", order: 123, type: ["cooperative"] },
	{ code: "cityUnionBankLtd", name: "City Union Bank Ltd", order: 124, type: ["private"] },
	{ code: "corporationBank", name: "Corporation Bank", order: 125, type: ["public"] },
	{ code: "cosmosCo-opBankLtd", name: "Cosmos Co-op Bank Ltd", order: 126, type: ["cooperative"] },
	{
		code: "creditAgricoleCorpandInvestmentBank",
		name: "Credit Agricole Corp and Investment Bank",
		order: 127,
		type: ["foreign"],
	},
	{ code: "commonwealthBankofAustralia", name: "Commonwealth Bank of Australia", order: 128, type: ["foreign"] },
	{ code: "dBSBank", name: "DBS Bank", order: 129, type: ["foreign"] },
	{ code: "denaBank", name: "Dena Bank", order: 130, type: ["public"] },
	{ code: "deutscheBankAg", name: "Deutsche Bank Ag", order: 131, type: ["foreign"] },
	{ code: "developmentCreditBank", name: "Development Credit Bank", order: 132, type: ["nbfc"] },
	{ code: "dhanlaxmiBankLtd", name: "Dhanlaxmi Bank Ltd", order: 133, type: ["private"] },
	{ code: "dhfl", name: "DHFL", order: 134, type: ["nbfc"] },
	{ code: "firstrandBankLtd", name: "Firstrand Bank Ltd", order: 135, type: ["foreign"] },
	{ code: "godrejHousingFinanceLimited", name: "Godrej Housing Finance Limited (GHFL)", order: 136, type: ["nbfc"] },
	{ code: "greaterBombayCo-opBankLtd", name: "Greater Bombay Co-op Bank Ltd", order: 137, type: ["cooperative"] },
	{ code: "hindujaHousingFinance", name: "Hinduja Housing Finance", order: 138, type: ["nbfc"] },
	{ code: "hSBC", name: "HSBC", order: 139, type: ["foreign"] },
	{ code: "iDBIBank", name: "IDBI Bank", order: 140, type: ["public"] },
	{ code: "iIFL", name: "IIFL - India Infoline", order: 141, type: ["nbfc"] },
	{ code: "indiaBulls", name: "India Bulls", order: 142, type: ["nbfc"] },
	{ code: "indianBank", name: "Indian Bank", order: 143, type: ["public"] },
	{ code: "indianOverseasBank", name: "Indian Overseas Bank", order: 144, type: ["public"] },
	{ code: "indusIndBankLtd", name: "IndusInd Bank Ltd", order: 145, type: ["private"] },
	{ code: "iNGVysyaBank", name: "ING Vysya Bank", order: 146, type: ["private"] },
	{ code: "karnatakBankLtd", name: "Karnataka Bank Ltd.", order: 147, type: ["private"] },
	{ code: "karnatakaStateCo-opApexBank", name: "Karnataka State Co-op Apex Bank", order: 148, type: ["cooperative"] },
	{ code: "karurVysyaBank", name: "Karur Vysya Bank", order: 149, type: ["private"] },
	{ code: "kotakMahindraBank", name: "Kotak Mahindra Bank", order: 150, type: ["private"] },
	{ code: "lakshmiVilasBankLtd", name: "Lakshmi Vilas Bank Ltd", order: 151, type: ["private"] },
	{ code: "licHousingFinance", name: "LIC Housing Finance", order: 152, type: ["nbfc"] },
	{ code: "lntFinance", name: "L & T Finance (LNT, L&T)", order: 153, type: ["nbfc"] },
	{ code: "nationalBankLtd", name: "Nainital Bank Ltd", order: 154, type: ["private"] },
	{ code: "orientalBank", name: "Oriental Bank of Commerce", order: 155, type: ["public"] },
	{ code: "punjabSindBank", name: "Punjab Sind Bank", order: 156, type: ["public"] },
	{ code: "relianceCapital", name: "Reliance Capital", order: 157, type: ["nbfc"] },
	{ code: "repcoBank", name: "Repco Bank", order: 158, type: ["cooperative"] },
	{ code: "reserveBankOfIndia", name: "Reserve Bank Of India", order: 159, type: ["central"] },
	{
		code: "sirMVisvesvarayaCo-opBankLtd",
		name: "Sir M. Visvesvaraya Co-operative Bank Ltd",
		order: 160,
		type: ["cooperative"],
	},
	{ code: "stateBankOfHydrabad", name: "State Bank of Hyderabad", order: 161, type: ["public"] },
	{ code: "stateBankOfMysore", name: "State Bank of Mysore", order: 162, type: ["public"] },
	{ code: "stateBankOfPatiala", name: "State Bank Of Patiala", order: 163, type: ["public"] },
	{ code: "stateBankOfTravancore", name: "State Bank Of Travancore", order: 164, type: ["public"] },
	{ code: "stateBankOfSaurashtra", name: "State Bank of Saurashtra", order: 165, type: ["public"] },
	{ code: "syndicateBank", name: "Syndicate Bank", order: 166, type: ["public"] },
	{ code: "sundaramHomeFinance", name: "Sundaram Home Finance", order: 167, type: ["nbfc"] },
	{ code: "tataFinance", name: "Tata Capital Finance", order: 168, type: ["nbfc"] },
	{ code: "ucoBank", name: "UCO Bank", order: 169, type: ["public"] },
	{ code: "unionBankOfIndia", name: "Union Bank of India", order: 170, type: ["public"] },
	{ code: "unitedOverseasBank", name: "United Overseas Bank", order: 171, type: ["foreign"] },
	{ code: "vijayBank", name: "Vijaya Bank", order: 172, type: ["public"] },
	{ code: "yesBank", name: "Yes Bank", order: 173, type: ["private"] },
];

export const getBankInfo = (code: string): Bank | undefined => {
	return banksInfo.find(bank => bank.code === code);
};

export const getBanksByCategory = (category: string): Bank[] => {
	return banksInfo.filter(bank => bank.category === category);
};

export const getBanksByType = (type: string): Bank[] => {
	return banksInfo.filter(bank => bank.type.includes(type));
};

export const getBankInfoByName = (name: string): Bank | undefined => {
	const normalizedName = name.toLowerCase().trim();

	// Try exact match by name, shortName, or code
	const exactMatch = banksInfo.find(
		bank =>
			bank.name.toLowerCase() === normalizedName ||
			bank.shortName?.toLowerCase() === normalizedName ||
			bank.code.toLowerCase() === normalizedName,
	);

	if (exactMatch) {
		return exactMatch;
	}

	// Try partial matching
	return banksInfo.find(
		bank =>
			bank.name.toLowerCase().includes(normalizedName) ||
			bank.shortName?.toLowerCase().includes(normalizedName) ||
			normalizedName.includes(bank.name.toLowerCase()) ||
			(bank.shortName && normalizedName.includes(bank.shortName.toLowerCase())),
	);
};

// Get banks sorted by order (prioritizes banks with logos)
export const getBanksSorted = (): Bank[] => {
	return banksInfo.sort((a, b) => a.order - b.order);
};

// Get only banks with logos
export const getBanksWithLogos = (): Bank[] => {
	return banksInfo.filter(bank => bank.logo).sort((a, b) => a.order - b.order);
};
